export const AGE_VERIFIED_KEY = "age_verified";
export const COOKIE_CONSENT_KEY = "cookie_consent";
export const ONBOARDING_COMPLETE_KEY = "forfada:onboardingComplete";
export const ONBOARDING_COMPLETE_EVENT = "forfada:onboarding-complete";

export function readFlag(key: string): boolean {
  try {
    return localStorage.getItem(key) === "true";
  } catch {
    return false;
  }
}

export function writeFlag(key: string, value = true): void {
  try {
    localStorage.setItem(key, value ? "true" : "false");
  } catch {
    /* ignore */
  }
}

export function isAgeVerified(): boolean {
  return readFlag(AGE_VERIFIED_KEY);
}

export function isOnboardingComplete(): boolean {
  return readFlag(ONBOARDING_COMPLETE_KEY);
}

export function markOnboardingComplete(): void {
  writeFlag(ONBOARDING_COMPLETE_KEY, true);
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(ONBOARDING_COMPLETE_EVENT));
  }
}